import {
    Field,
    FormikProps
} from 'formik';

import {
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {
    Stack,
    Switch
} from "@mantine/core";
import {
    PaymentProfile
} from "../types.ts";
import {useState} from "react";
import {BillingProvidersAutocomplete} from "../../billing-providers/inputs/BillingProvidersAutocomplete.tsx";


export const FormComponent = (props: FormikProps<PaymentProfile>) => {

    const initialOption = props.values.description ? true : false
    const [showDescription, setShowDescription] = useState(initialOption)

    return (
        <Stack gap={'xl'}>
            <PlatformFieldset legend={'Payment Profile'}>

                <Field
                    name='name'
                    label='Name'
                    description='Please enter the payment profile name'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='billingProviderId'
                    label='Billing Provider'
                    description='Please select the billing provider'
                    component={BillingProvidersAutocomplete}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='providerPaymentMethodId'
                    label='Provider Payment Method ID'
                    description='Please enter the provider payment method ID'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Switch
                    checked={showDescription}
                    label={'Add Profile Description'}
                    onChange={(event) => setShowDescription(event.currentTarget.checked)}
                    my={'xl'}
                />

                {showDescription ?
                    <Field
                        name='description'
                        label='Description'
                        description='Please enter payment profile description'
                        component={FormikTextarea}
                        my={'xl'}
                    /> : null}

            </PlatformFieldset>

        </Stack>
    );
};
